import type { Money } from 'types/product/Money';

export const getGalleryPriceBadge = ({
  isNewPrice,
  price,
  compareAtPrice,
}: {
  isNewPrice: boolean;
  price?: Money | null;
  compareAtPrice?: Money | null;
}) => {
  if (!isNewPrice || !price || !compareAtPrice) return null;

  return { price, compareAtPrice };
};
